import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { useAppSelector } from 'store';
import { LocalStorage } from 'services';

import { CustomButton } from 'components/CustomButton/CustomButton';
import {
  SLayout,
  STitle,
  SDescription,
  SVerifyRow,
  SVerifyText,
  SVerifyVal,
} from './DeviceVerifyWarningPage.styles';

const EmailIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="#1890ff"/>
  </svg>
);

const DeviceVerifyWarningPage: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  
  const { lastUsername, clientDetails } = useAppSelector((state) => state.auth);

  useEffect(() => {
    try {
      const otpFlowData = LocalStorage.get('LOGIN_OTP_FLOW');
      
      if (otpFlowData && otpFlowData.transactionId) {
        if (otpFlowData.maskedEmail) {
          setEmail(otpFlowData.maskedEmail);
        } else {
          const fallbackEmail = clientDetails?.email || lastUsername || '';
          setEmail(fallbackEmail);
        }
      } else {
        message.error('No verification session found. Please login again.');
        navigate('/login', { replace: true });
      }
    } catch (error) {
      message.error('Failed to retrieve verification session. Please login again.');
      navigate('/login', { replace: true });
    }
  }, [clientDetails?.email, lastUsername, navigate]);

  const handleContinue = () => {
    if (!email) {
      message.error('No verification data found. Please login again.');
      navigate('/login', { replace: true });
      return;
    }

    navigate('/verify-device');
  };

  return (
    <SLayout>
      <STitle>Device Verification</STitle>

      <SDescription>
        For your security, a verification code will be sent to your registered 
        email address below to verify this device.
      </SDescription>

      <SVerifyRow>
        <EmailIcon />
        <SVerifyText>
          Email: <SVerifyVal>{email}</SVerifyVal>
        </SVerifyText>
      </SVerifyRow>

      <CustomButton 
        type="primary" 
        block 
        buttonSize="large" 
        htmlType="submit" 
        onClick={handleContinue}
      >
        Continue
      </CustomButton>
    </SLayout>
  );
};

export default DeviceVerifyWarningPage; 